<template>
    <div class="p-4">
        <div class="text-16 font-bold text-a-brown-9f8273 mb-3">
            <HelloMessage></HelloMessage>
            <span v-if="isLoginAccount" class="text-a-brown-502314">{{userFirstname}}</span>
            <!-- <span v-else class="text-a-brown-502314">{{lbl.main.guest}}</span> -->
        </div>

        <div class="bg-a-brown-e7d7c1 rounded-14 p-1" v-if="isInitial">
            <div class="delivery-tab-hover relative w-full">
                <div class="absolute top-0 delivery-tab w-1/2 bg-a-egg-f5ebdc rounded-t-12 duration-700"
                    :class="{'left-0': delivery.deliveryMethod == 'Delivery','left-1/2': delivery.deliveryMethod == 'InStore'}"
                ></div>
                <div class="absolute top-0 left-0 w-full grid grid-cols-2 text-center text-14 font-bold text-a-brown-502314">
                    <div class="py-2 rounded-t-12"
                        :class="[classTabActive('Delivery')]"
                        @click="clickTab('Delivery')">{{lbl.deliverymethod.delivery}}</div>
                    <div class="py-2 rounded-t-12"
                        :class="[classTabActive('InStore')]"
                        @click="clickTab('InStore')">{{lbl.deliverymethod.self_pickup}}</div>
                </div>
            </div>
            <div v-show="delivery.deliveryMethod == 'Delivery'" @click="clickStartYourOrder()" class="bg-a-egg-f5ebdc p-4 rounded-b-12 rounded-tr-12">
                <div class="border-b border-a-brown-502314" v-if="delivery.address">
                    <div class="flex pb-1">
                        <img src="@/assets/delivery/ic-delivery.svg" />
                        <div class="text-12 my-auto ml-2 text-a-brown-9f8273">{{lbl.deliverymethod.delivery_to}}</div>
                    </div>
                    <div class="flex">
                        <div class="address text-14 text-a-brown-502314">{{delivery.address.addressName}}</div>
                        <img src="../../../../assets/icon/ic-arrow-right-brown.svg" />
                    </div>
                </div>
                <div class="flex justify-center bg-a-red-d62300 rounded-full py-3" v-else>
                    <img src="../../../../assets/delivery/Order-type.svg">
                    <div class="text-a-egg-f5ebdc text-16 font-bold ml-2" >{{lbl.deliverymethod.start_your_order}}</div>
                </div>
            </div>
            <div v-show="delivery.deliveryMethod == 'InStore'" @click="clickStartYourOrder()" class="bg-a-egg-f5ebdc p-4 rounded-b-12 rounded-tl-12">
                <div class="border-b border-a-brown-502314" v-if="delivery.location && delivery.deliveryMethod == 'InStore' && deliveryTmp.deliveryMethod == 'InStore'">
                    <div class="flex pb-1">
                        <img src="@/assets/delivery/ic-delivery.svg" />
                        <div class="text-12 my-auto ml-2 text-a-brown-9f8273">Pick up at</div>
                    </div>
                    <div class="flex">
                        <div class="address text-14 text-a-brown-502314">{{localeCode == 1033 ? delivery.location.nameEN : delivery.location.name}}</div>
                        <img src="../../../../assets/icon/ic-arrow-right-brown.svg" />
                    </div>
                </div>
                <div class="flex justify-center bg-a-red-d62300 rounded-full py-3" v-else>
                    <img src="../../../../assets/delivery/shop.svg">
                    <div class="text-a-egg-f5ebdc text-16 font-bold ml-2">{{lbl.deliverymethod.start_your_order}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import Util from '@/helper/Utility.js';
import Account from '@/helper/AccountHelper.js';
import HelloMessage from './HelloMessage.vue';
import DeliveryHelper from '@/helper/DeliveryHelper';
// mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin'
import DeliveryMixin from '@/mixin/DeliveryMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin.js';
// service
import BKDeliveryMethod from "@/module/DeliveryMethod/service/BKDeliveryMethod.js";

export default {
    inject: ['CartCountStore'],
    mixins: [AuthStatusMixin, DeliveryMixin, LocaleMixin, ModalMixin],
    components: {
        HelloMessage,
    },
    data: function () {
        return {
            deliveryTmp: null
        };
    },
    mounted: function () {
        // Util.log('delivery', this.delivery);
    },
    created: function() {
        console.log('delivery', this.delivery);
    },
    methods: {
        onAccountInit: function() {
            //this.deliveryInit();
            this.deliveryTmp = {...this.delivery};
        },
        onDeliveryUpdate: function() {
            let selectBranchCache = DeliveryHelper.getCacheSelectBranch();
        
            if (selectBranchCache && selectBranchCache.isSelectBranch) {
                DeliveryHelper.removeCacheSelectBranch()
                this.clickTab('InStore')
                this.clickStartYourOrder();
            }
        },
        classTabActive: function (tab) {
            if (tab == this.delivery.deliveryMethod) {
                return 'text-a-red-d62300';
            }
            return '';
        },
        getAddress: function () {
            var address = "";
            if (this.delivery.address.number) {
                address += this.delivery.address.number + " ";
            }
            if (this.delivery.address.soi) {
                address += this.delivery.address.soi + " ";
            }
            if (this.delivery.address.subDistrictName) {
                address += this.delivery.address.subDistrictName + " ";
            }
            if (this.delivery.address.districtName) {
                address += this.delivery.address.districtName + " ";
            }

            if (this.delivery.address.zipcode) {
                address += this.delivery.address.zipcode;
            }
            return address;
        },
        clickTab: function (tab) {
            this.delivery.deliveryMethod = tab;
        },
        clickStartYourOrder: function() {
            this.getPermissionDelivery();
        },
        redirectDelivery: function() {
            if (this.delivery.deliveryMethod == 'Delivery' && !this.delivery.address) {
                this.updateIsFromDeliveryMethod(true);
            } else {
                this.updateIsFromDeliveryMethod(true);
            }

            this.$router.push('/deliverymethod');
        },
        deniedPermission: function () {
            let msg_permission = "";
            if (this.delivery.deliveryMethod == 'Delivery') {
                msg_permission = this.lbl.error_delivery.delivery;
            } else {
                msg_permission = this.lbl.error_delivery.instore;
            }

            this.modal.errorModal
                        .clearModal()
                        .setMsg(msg_permission)
                        .show();
            this.modal.errorModal.onClose(()=> {
                this.CartCountStore.methods.deleteCartAll();
            })
        },
        getPermissionDelivery: async function() {
            let objPermission = await this.apiGetPermissionDelivery();
            
            if (objPermission) {
                Account.checkPermision(objPermission,this.isLoginGuest,this.delivery.deliveryMethod,()=>{
                    this.redirectDelivery();
                },()=>{
                    this.deniedPermission();
                });
            }
        },
        apiGetPermissionDelivery: function() {
            return new Promise((resolve)  => {
                BKDeliveryMethod.apiGetPermissionDelivery().subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(null);
                    },
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    .address {
        @extend %ellipsis-1;
    }
    .delivery-tab-hover {
        height: 37px;
    }
    .delivery-tab {
        height: 37px;
    }
</style>
